import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiAppearanceStartPageModule } from './start-page/start-page.module';
import { FiAppearanceWidgetSettingsWrapModule } from './widget-settings-wrap/widget-settings-wrap.module';
import { FiAppearanceAvailableWidgetsListModule } from './available-widgets-list/available-widgets-list.module';
import { FiAppearanceSidebarModule } from './sidebar/sidebar.module';
import { DndModule } from 'ngx-drag-drop';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiStateSrefModule } from '../shared/fi-state-proxy/state-sref/state-sref.module';
import { FiAppearanceViewComponent } from './appearance-view.component';
import { FiAppearanceListViewModule } from './list-view/list-view.module';
import { FiAppearanceTrashBinModule } from './trash-bin/trash-bin.module';
import { FiCustomerSettingsModule } from './customer-settings/customer-settings.module';
import { FiAuthenticateModule } from '../authenticate/authenticate.module';
import { UIRouterModule } from '@uirouter/angular';
import { FiAppearanceStates } from '@fi-app/appearance/appearance-states';
import { ButtonBackModule } from '@fi-app/utilities/button-back/button-back.module';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';

@NgModule({
    imports: [
        CommonModule,
        DndModule,
        FiAppTextSharedModule,
        FiAppearanceStartPageModule,
        FiAppearanceSidebarModule,
        FiAppearanceWidgetSettingsWrapModule,
        FiAppearanceAvailableWidgetsListModule,
        FiStateSrefModule,
        FiAppearanceListViewModule,
        FiAppearanceTrashBinModule,
        FiCustomerSettingsModule,
        FiAuthenticateModule,
        UIRouterModule.forChild(FiAppearanceStates),
        ButtonBackModule,
        FiLoadingModule,
    ],
    declarations: [FiAppearanceViewComponent],
    providers: [],
    exports: [
        FiAppearanceStartPageModule,
        FiAppearanceSidebarModule,
        FiAppearanceViewComponent,
        FiAppearanceListViewModule,
        FiAppearanceTrashBinModule,
    ],
})
export class FiAppearanceModule {}
